import { z } from 'zod';

export const CoreBackgroundJobScalarFieldEnumSchema = z.enum(['id','cityId','userId','emailResultsTo','name','jobType','status','isTest','stepCurrent','stepTotal','stepProgressMessage','progressPercentage','progressMessage','recordsTotal','recordsProcessed','jobDetails','jobError','errorCount','s3ResultsKey','results','createdAt','startedAt','endedAt','cancelRequestedAt']);

export default CoreBackgroundJobScalarFieldEnumSchema;
